import type { FeedContribution } from "../../domain/tenantModule";

/**
 * KCC's own feeds (api2 `app/tenants/kcc/ingest/feeds.py`, registered there through
 * `ModuleDescriptor.feeds`): the three kinds KCC records under its own names, and the catalogue
 * identity of its two sales feeds. Core's six neutral kinds — KCC's STR, STO, calendar, material
 * master and lane/mode/carrier feeds are recorded under them — are core's to list.
 */
export const kccFeeds: FeedContribution = {
  kinds: [
    { kind: "sales_order", label: "Sales orders" },
    { kind: "sales_forecast", label: "Sales forecast" },
    /* What `GET /integration/kc/sto` served: recorded, never current. */
    { kind: "sto_output", label: "STO output served" },
  ],
  sources: [
    {
      id: "kcc-sales",
      name: "Customer demand feeds",
      system: "KCC sales systems",
    },
  ],
  datasets: [
    {
      id: "sales-orders",
      title: "Sales orders",
      ownership: "feed",
      sourceId: "kcc-sales",
      deliveryKind: "sales_order",
      description: "Confirmed customer demand used as an input to network planning.",
      path: "/kcc/sales-orders",
      permissionPath: "/kcc/sales-orders",
    },
    {
      id: "sales-forecast",
      title: "Sales forecast",
      ownership: "feed",
      sourceId: "kcc-sales",
      deliveryKind: "sales_forecast",
      description: "Forecast customer demand used to shape the forward transport plan.",
      path: "/kcc/sales-forecasts",
      permissionPath: "/kcc/sales-forecasts",
    },
  ],
};
